import * as immu from 'object-path-immutable'
import isEqual from 'lodash/isEqual'

// -----------------------------
// Get rules for ids array
// - substance if preflight false
// - kinetic
// - adverse
// - warning
// -----------------------------
export function rulesByIds( ids, preflight = false ) {

  return async ( dispatch, getState, api ) => {

    // Quality control
    if ( !ids || Array.isArray( ids ) == false || ids.length == 0 ) {
      return {}
    }

    // Collector
    const rules = {}

    // ---------------------------------
    // Standard rules with drug
    // ---------------------------------
    const q1 = `drug:(${ids.join(" OR ")})`
    // Rules with groups
    const groups = [ "kinetic", "adverse", "nutrition" ]
    // No preflight so add substance
    if ( !preflight ) groups.push( "substance" )
    // Prepare query
    const q2 = `group:(${groups.join(" OR ")} )`
    // Fetch
    const { meta: meta1, data: data1 } = await api.simple.find( {
      index: "rule",
      body: {
        query: {
          query_string: {
            query: `${q1} AND ${q2}`
          }
        },
        size: 200
      }
    } )

    if ( meta1.code == 200 && Array.isArray( data1 ) ) {

      // Convert array to standard object
      for ( const rule of data1 ) {
        if ( rule.id ) {
          rules[ rule.id ] = rule
        } else {
          console.log( "> elastic rulesByIds rule", rule.id )
        }
      }

      // Transform rule.adverse text in structured dict
      for ( const id in rules ) {
        // Structure translation coming in text
        if ( rules[ id ].group == "adverse" ) {
          for ( const lang in rules[ id ][ "text" ] ) {
            rules[ id ][ "text" ][ lang ] = rules[ id ][ "text" ][ lang ].split( "|" ).reduce( ( acc, cur ) => {
              const [ key, value ] = cur.split( ":" )
              return immu.set( acc, key, value )
            }, {} )
          }
        }
      }

    } else {
      console.log( "Error: data-elastic rulesByIds failed" )
      if ( process.env.NODE_ENV == "develop" ) {
        console.log( meta1 )
        console.log( data1 )
      }
    }

    // ----------------------------
    // Rules warning without drug
    // ----------------------------
    // q3.push( `group:warning` )
    // q3.push( `conditions:("drug1:terbinafin" OR "drug1:metoprolol" OR "drug1:trimipramin")` )
    // q3.push( `conditions:("drug2:terbinafin" OR "drug2:metoprolol" OR "drug2:trimipramin")` )
    const q3 = []
    q3.push( `group:warning` )
    q3.push( `conditions:(${ids.map( id => `"drug1:${id}"`).join( " OR ")})` )
    q3.push( `conditions:(${ids.map( id => `"drug2:${id}"`).join( " OR ")})` )

    const { meta: meta2, data: data2 } = await api.simple.find( {
      index: "rule",
      body: {
        query: {
          query_string: {
            query: q3.join( " AND " )
          }
        },
        size: 100
      }
    } )

    /* [
      {
        conditions: (2) ["drug1:erythromycin", "drug2:simvastatin"]
        drug: ""
        grad: "X"
        group: "warning"
        id: "ocq6lc4s5e"
        info: "Myopathie.json"
        pubmed: (3) ["9728898", "17296622", "17381388"]
        status: ["update"]
        text: {de: "<h3>Erhöhtes Myopathie- und R.." }
      }
    ] */
    if ( meta2.code == 200 && Array.isArray( data2 ) ) {
      // Convert array to standard object
      for ( const rule of data2 ) {
        if ( rule.id ) {
          // Check for Duplicates based on conditions
          const virgin = Object.values( rules ).every( r => {
            return isEqual( r.conditions, rule.conditions ) === false
          } )
          if ( virgin ) {
            rules[ rule.id ] = rule
          }
        } else {
          console.log( "> elastic rulesByIds rule", rule.id )
        }
        // Debug
        // console.log( rule )
        // console.log( rule.id, rule.grad, rule.info )
        // console.log( rule.conditions.join( " " ) )
        // console.log( "--------------" )
      }
    } else {
      console.log( "Error: data-elastic rulesByIds failed" )
      if ( process.env.NODE_ENV == "develop" ) {
        console.log( meta2 )
        console.log( data2 )
      }
    }

    // ------------------------------------
    // @Developing TODO
    // Add test rule for alter
    // ------------------------------------
    // rules[ "zolpidem-alter-avoid" ] = {
    //   id: "zolpidem-alter-avoid",
    //   drug: "zolpidem",
    //   group: "alter",
    //   subgroup: [ "adjust" ],
    //   conditions: [
    //     "age.years:senior",
    //     "zolpidem.dose:medium"
    //   ],
    //   text: {
    //     "de": "Zolpidem sollte bei Patienten über 65 Jahre nicht über 5mg am Tag liegen."
    //   },
    //   pubmed: [ "1234" ]
    // }

    return rules

  }

}